import { useVModel as e } from "../node_modules/.pnpm/@vueuse_core@13.3.0_vue@3.5.16_typescript@6.0.2_/node_modules/@vueuse/core/index.js";
import { computed as t, ref as n, watch as r } from "vue";
//#region src/composables/useBetterVModel.ts
function i({ props: i, realProps: a, key: o = "modelValue", emits: s, defaultValue: c }) {
	let l = Object.hasOwn(a, o), u = e(i, o, s, {
		passive: !1,
		defaultValue: c
	}), d = n(u.value ?? c);
	return r(() => i[o], (e) => {
		l && (d.value = e);
	}), t({
		get: () => l ? u.value : d.value,
		set: (e) => {
			l ? u.value = e : (d.value = e, s?.(`update:${o}`, e));
		}
	});
}
//#endregion
export { i as useBetterVModel };

//# sourceMappingURL=useBetterVModel.js.map